import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Typography,
} from '@mui/material';

const IntervalSelector = ({ interval, setInterval }) => {
  // TODO this is used to prevent the card from flipping when clicking on the radio buttons
  // find a better way to do this, like in the RadioGroup/FormControl or handleIntervalChange?
  const preventCardFlip = (e) => {
    e.stopPropagation();
  };

  return (
    // TODO this gives drop shadow on cardinput which is lame
    <div
      style={{
        background: 'white',
        paddingLeft: '10px',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(15, 15, 15, 0.6)',
      }}
    >
      <FormControl>
        {/* TODO when user selects interval on card without subs, this changes to 'Select' which is not desirable */}
        {/* <FormLabel id='select-interval-label'>{interval ? 'Change' : 'Select'} Interval</FormLabel> */}
        <RadioGroup
          aria-labelledby='select-interval-label'
          value={interval}
          name='select-interval-group'
          onChange={(newInterval) => setInterval(newInterval.target.value)}
        >
          <FormControlLabel
            onClick={preventCardFlip}
            value='MONTHLY'
            control={<Radio />}
            label={
              <Typography variant='body2' color='textSecondary'>
                Monthly: Every 30 days (recommended)
              </Typography>
            }
          />
          <FormControlLabel
            onClick={preventCardFlip}
            value='QUARTERLY'
            control={<Radio />}
            label={
              <Typography variant='body2' color='textSecondary'>
                Quarterly: Every 3 months
              </Typography>
            }
          />
          <FormControlLabel
            onClick={preventCardFlip}
            value='SEMIANNUALLY'
            control={<Radio />}
            label={
              <Typography variant='body2' color='textSecondary'>
                Semi-Annually: Every 6 months
              </Typography>
            }
          />
        </RadioGroup>
      </FormControl>
    </div>
  );
};

export default IntervalSelector;
